import clsx from 'clsx';
import type { CSSProperties, FC } from 'react';
import { Button, Card, Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@furality/frontend-stack';
import LanguageChangerDropdown from '@/components/LanguageChangerDropdown.tsx';
import Overlapping from '@/components/Overlapping.tsx';
import Placeholder from '@/components/Placeholder.tsx';
import useLoading from '@/lib/hooks/useLoading.ts';
import type TranslationKey from '@/lib/i18n/TranslationKey.ts';

import styles from './ConventionHeaderBig.module.scss';

const FynnSmileUrl = 'https://cdn.furality.org/files/web/fynn/fynn-smile.png';

type ConventionHeaderProps = {
  title?: TranslationKey;
};

const ConventionHeaderBig: FC<ConventionHeaderProps> = ({ title }) => {
  const { t } = useTranslation(['common', 'register']);
  const auth = useAuth();

  const loading = useLoading();

  return (
    <section className="bg-section-secondary main-background-2" style={{}}>
      <header className="header header-transparent" style={{ zIndex: 1000 }}>
        <Navbar
          className="furality-navbar bg-none"
          style={{ '--nav-height': 'auto' } as CSSProperties}
        >
          <Container className="px-lg-0">
            <Card className="ms-auto p-2 rounded-0 rounded-bottom-4">
              <Nav className="gap-2">
                <LanguageChangerDropdown />
                {auth.state === 'loggedIn' && (
                  <Button onClick={() => auth.logout()} size="sm" variant="outline-danger">
                    {t('logout')}
                  </Button>
                )}
              </Nav>
            </Card>
          </Container>
        </Navbar>
      </header>

      <Overlapping
        style={{
          maxHeight: '30rem',
        }}
      >
        <Row className="overflow-hidden flex-center mx-0">
          <Col lg={12} xl={4} className="flex-center">
            <div className="zindex-101 text-center">
              <img
                // CON-SPECIFIC
                alt="Furality Ultra"
                src="https://cdn.furality.org/files/web/logo/furality-ultra-logo.svg"
                className={clsx('img-fluid img-center my-4', styles['bannerPicture'])}
                style={{ width: '600px', height: 'auto' }}
              />
              <div className="mb-5">
                {title && (
                  <h1 className="h1 text-black">
                    {loading ? <Placeholder width="12em" /> : t(title)}
                  </h1>
                )}
                <h6 className="text-sm text-uppercase ls-2 text-dark">
                  {loading ? (
                    <Placeholder width="10em" />
                  ) : (
                    // TODO: move elsewhere?
                    // CON-SPECIFIC: con dates
                    // TODO: this should not be in register namespace
                    t('register:date_range.f9')
                  )}
                </h6>
              </div>
            </div>
          </Col>
          <Col lg={4} xl={4} className="d-none d-xl-flex justify-content-center h-100 mb--200">
            <img
              src={FynnSmileUrl}
              alt="fynn"
              className="img-fluid w-auto"
              style={{
                // TODO: make class
                transform: 'scaleX(-1)',
              }}
            />
          </Col>
        </Row>
      </Overlapping>
    </section>
  );
};

export default ConventionHeaderBig;
